import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getBranchDiscount = id => {
  return http.get(
    `${getBaseUrl()}/branch_discount/${id}`
  );
};

export const getBranchDiscounts = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/branch_discount`
    );
  }
  return http.get(
    `${getBaseUrl()}/branch_discount?${paginate}`
  );
};

export const updateBranchDiscount = data => {

  return http.put(
    `${getBaseUrl()}/branch_discount/${data.id}`,
    data
  );
};
export const submitBranchDiscount = data => {

  return http.post(
    `${getBaseUrl()}/branch_discount`,
    data
  );
};
